<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p style="text-indent:00em; padding-top:15px;">John Somerset is the best-selling author of <em>Lasseter’s Truth</em> and <em>The Excalibur File</em>. He was born in Melbourne, Australia and educated at Geelong Grammar and Melbourne University.</p>
<p style="text-indent:00em; padding-top:15px;">He spent his working life in international marketing and latterly advertising, is a winner of the Hoover Award for Marketing, Australia’s premier marketing award of its time and is a qualified PADI scuba diver.</p>
<p style="text-indent:00em; padding-top:15px;">He lives and writes at Anglesea, Victoria with his wife and one-eyed kelpie.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?61f045a4